export enum PersonTypeEnum {
    None = 0,
    Customer = 1,
    Agent = 2
}
